import ExcelJS from "exceljs";

export const generateExcel = (data, fileName) => {
  const workbook = new ExcelJS.Workbook();
  
  // Check if data is an array of sheet objects or just a single data array
  if (Array.isArray(data) && data.length > 0 && data[0].name && data[0].data) {
    // Multiple sheets structure: [{name: "Sheet1", data: [...]}, {name: "Sheet2", data: [...]}]
    console.log("Creating multiple sheets:", data);
    
    data.forEach(({ name, data: sheetData }, sheetIndex) => {
      console.log(`Processing sheet ${sheetIndex + 1}:`, { name, dataLength: sheetData?.length });
      
      if (sheetData && Array.isArray(sheetData) && sheetData.length > 0) {
        const worksheet = workbook.addWorksheet(name);
        const columns = Object.keys(sheetData[0]).map((key) => ({ header: key, key }));
        worksheet.columns = columns;

        sheetData.forEach((item) => worksheet.addRow(item));

        // Style headers
        columns.forEach((col, index) => {
          const headerCell = worksheet.getCell(1, index + 1);
          headerCell.font = { bold: true, color: { argb: "FFFFFF" }, size: 12 };
          headerCell.alignment = { horizontal: "center", vertical: "middle" };
          headerCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "4F81BD" },
          };
        });

        // Auto column width - fix the undefined values issue
        worksheet.columns.forEach((col, index) => {
          if (col && col.key) {
            // Get all values for this column including header and data
            const headerLength = String(col.header || "").length;
            const dataValues = sheetData.map(row => String(row[col.key] || "")).filter(Boolean);
            const maxDataLength = dataValues.length > 0 ? Math.max(...dataValues.map(val => val.length)) : 0;
            const maxLength = Math.max(headerLength, maxDataLength);
            col.width = maxLength + 2;
          }
        });
      }
    });
  } else {
    // Single sheet structure: just an array of data objects
    console.log("Creating single sheet with data:", data);
    const worksheet = workbook.addWorksheet("data");

    const columns = data && Object.keys(data?.[0] || {}).map((key) => ({ header: key, key }));
    worksheet.columns = columns;

    data.forEach((item) => worksheet.addRow(item));

    // Style headers
    columns.forEach((col, index) => {
      const headerCell = worksheet.getCell(1, index + 1);
      headerCell.font = { bold: true, color: { argb: "FFFFFF" }, size: 12 };
      headerCell.alignment = { horizontal: "center", vertical: "middle" };
      headerCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "4F81BD" },
      };
    });

    // Auto column width - fix the undefined values issue
    worksheet.columns.forEach((col, index) => {
      if (col && col.key) {
        // Get all values for this column including header and data
        const headerLength = String(col.header || "").length;
        const dataValues = data.map(row => String(row[col.key] || "")).filter(Boolean);
        const maxDataLength = dataValues.length > 0 ? Math.max(...dataValues.map(val => val.length)) : 0;
        const maxLength = Math.max(headerLength, maxDataLength);
        col.width = maxLength + 2;
      }
    });
  }

  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${fileName}.xlsx`;
    link.click();
  });
};

export default generateExcel;
